import { render, staticRenderFns } from "./OutcomeRingCard.vue?vue&type=template&id=3fd45e25&scoped=true"
import script from "./OutcomeRingCard.vue?vue&type=script&lang=js"
export * from "./OutcomeRingCard.vue?vue&type=script&lang=js"
import style0 from "./OutcomeRingCard.vue?vue&type=style&index=0&id=3fd45e25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd45e25",
  null
  
)

export default component.exports